import React from 'react';

export default function TextSkeleton() {
  return (
    <div className='tw-flex tw-h-full tw-overflow-hidden'>
      <div className='tw-ml-2 tw-flex tw-h-full tw-w-full tw-min-w-[26px] tw-animate-pulse tw-items-center tw-justify-center'>
        <div className='tw-h-3 tw-w-full tw-rounded-lg tw-bg-grey-100' />
      </div>
      <div className='tw-w-11' />
    </div>
  );
}
